// removed by extract-text-webpack-plugin
module.exports = {"wrap":"_30vorzcoCFMUaTN2Wtjv4C","default":"_2mkr53T59U6bupqDXVzTHh","high":"_28YTiDbWiDjJUn7itxtAU3","blink":"_10X0u6EFuDEtBG69IWKdI4","low":"_2bisP16zBoVObjjBle6Spi"};


//////////////////
// WEBPACK FOOTER
// ./src/components/entries/BA/style.css
// module id = 334
// module chunks = 0